import { HelpTip } from './types';

export const ADMINISTRATION_TIPS = {
  /* === API calls history === */
  endpointHistoryTable: {
    title: { fr: 'Historique des appels API', en: 'API calls history' },
    text: {
      fr: "Journal des appels reçus par l'API d'inspection (routes /vehiculeCheck, /vehiculeCheckResult et /mobil/data) depuis l'application mobile ou une intégration client. Les appels faits depuis ce back-office ne sont pas enregistrés. Les appels les plus récents sont affichés en premier.",
      en: 'Log of the calls received by the inspection API (/vehiculeCheck, /vehiculeCheckResult and /mobil/data routes) from the mobile app or a customer integration. Calls made from this back office are not recorded. The most recent calls are displayed first.',
    },
    docSlug: 'historique-des-appels-api',
  },
  endpointClientColumn: {
    title: { fr: "Auteur de l'appel", en: 'Caller' },
    text: {
      fr: "Utilisateur à l'origine de l'appel (utilisateur connecté ou utilisateur indiqué dans la requête), avec les groupes, sociétés et exploitations auxquels il est rattaché. « -- » lorsque l'appel n'est lié à aucun utilisateur identifié.",
      en: 'User behind the call (logged-in user or user given in the request), with the groups, companies and branches they are linked to. "--" when the call is not linked to an identified user.',
    },
    docSlug: 'historique-des-appels-api',
  },
  endpointMethodColumn: {
    title: { fr: 'Méthode HTTP', en: 'HTTP method' },
    text: {
      fr: 'GET = lecture de données, POST = création (ex. nouvelle inspection), PATCH / PUT = mise à jour, DELETE = suppression.',
      en: 'GET = reading data, POST = creation (e.g. new inspection), PATCH / PUT = update, DELETE = deletion.',
    },
    docSlug: 'historique-des-appels-api',
  },
  endpointSchemaColumn: {
    title: { fr: 'Route appelée', en: 'Called route' },
    text: {
      fr: "Modèle de la route, avec ses paramètres en couleur (ex. :id). Utile pour regrouper les appels d'un même type quelle que soit l'inspection concernée.",
      en: 'Route pattern, with its parameters highlighted (e.g. :id). Useful to group calls of the same kind whatever the inspection concerned.',
    },
    docSlug: 'historique-des-appels-api',
  },
  endpointUrlColumn: {
    title: { fr: 'URL avec valeurs', en: 'URL with values' },
    text: {
      fr: "Adresse réellement appelée, avec les valeurs des paramètres (identifiants, numéro de référence…). La recherche par plaque ou VIN retrouve les appels liés à l'inspection du véhicule.",
      en: "Address actually called, with the parameter values (ids, reference number…). Searching by plate or VIN finds the calls linked to the vehicle's inspection.",
    },
    docSlug: 'historique-des-appels-api',
  },

  /* === Correction engine === */
  engineCorrectionTable: {
    title: { fr: 'Moteur de correction', en: 'Correction engine' },
    text: {
      fr: "Images analysées par l'IA (détection des éléments du véhicule et des dommages), à relire et corriger par un modérateur pour améliorer les modèles. Les images sont triées de la plus récemment modifiée à la plus ancienne. « Commencer la modération » ouvre la prochaine image à modérer.",
      en: 'Images analysed by the AI (detection of vehicle parts and damages), to be reviewed and corrected by a moderator to improve the models. Images are sorted from the most recently modified to the oldest. "Start moderation" opens the next image to moderate.',
    },
    docSlug: 'moteur-de-correction',
  },
  elementsDetectedColumn: {
    title: { fr: 'Éléments détectés', en: 'Detected elements' },
    text: {
      fr: "Nombre d'éléments du véhicule (portière, capot, roue…) trouvés par l'IA sur l'image, avant toute correction.",
      en: 'Number of vehicle parts (door, bonnet, wheel…) found by the AI on the image, before any correction.',
    },
    docSlug: 'moteur-de-correction',
  },
  damagesDetectedColumn: {
    title: { fr: 'Dommages détectés', en: 'Detected damages' },
    text: {
      fr: "Nombre de dommages (rayure, bosse…) trouvés par l'IA sur l'image, avant toute correction.",
      en: 'Number of damages (scratch, dent…) found by the AI on the image, before any correction.',
    },
    docSlug: 'moteur-de-correction',
  },
  elementCorrectionsColumn: {
    title: { fr: 'Corrections des éléments', en: 'Element corrections' },
    text: {
      fr: "Nombre de modifications faites par les modérateurs sur les éléments détectés (ajout, suppression ou modification d'une zone).",
      en: 'Number of changes made by moderators on the detected elements (zone added, removed or changed).',
    },
    docSlug: 'moteur-de-correction',
  },
  damageCorrectionsColumn: {
    title: { fr: 'Corrections des dommages', en: 'Damage corrections' },
    text: {
      fr: "Nombre de modifications faites par les modérateurs sur les dommages détectés (ajout, suppression ou modification d'une zone).",
      en: 'Number of changes made by moderators on the detected damages (zone added, removed or changed).',
    },
    docSlug: 'moteur-de-correction',
  },
  imageOriginColumn: {
    title: { fr: "Origine de l'image", en: 'Image origin' },
    text: {
      fr: "« Uploadée » : image envoyée manuellement depuis ce back-office (bouton « Uploader des images ») ; seules ces images peuvent être modifiées ou supprimées, tant qu'elles ne sont pas modérées. « Réception automatisée » : image reçue automatiquement depuis les inspections.",
      en: '"Uploaded": image sent manually from this back office ("Upload images" button); only these images can be edited or deleted, as long as they are not moderated. "Automated receipt": image received automatically from inspections.',
    },
    docSlug: 'moteur-de-correction',
  },
  moderationColumn: {
    title: { fr: 'Modération', en: 'Moderation' },
    text: {
      fr: "« À modérer » : l'image n'a pas encore été relue. « Modérée » : un modérateur a validé ses détections. Une image modérée est ensuite « À vérifier » jusqu'à ce qu'un second contrôle la passe à « Vérifiée ».",
      en: '"To moderate": the image has not been reviewed yet. "Moderated": a moderator validated its detections. A moderated image is then "To verify" until a second check marks it "Verified".',
    },
    docSlug: 'moteur-de-correction',
  },
} satisfies Record<string, HelpTip>;
